import gql from 'graphql-tag';

export const UserFragment = gql`
  fragment UserFragment on User {
    id
    state
    firstName
    lastName
    email
    phone
    language
    showGetStarted
    role {
      id
      name
    }
    profilePicture {
      url
    }
  }
`;

export const OrganizationFragment = gql`
  fragment OrganizationFragment on Organization {
    id
    name
    logo {
      url
    }
    roles {
      id
    }
  }
`;
